import { render } from "./TableEntries.vue?vue&type=template&id=0fa8c7d6"
import script from "./TableEntries.vue?vue&type=script&lang=js"
export * from "./TableEntries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__